export const userSelector = state => state.user.user;
export const isLoggedInSelector = state => state.user.isLoggedIn;
export const userStateSelector = state => state.user;
export const employeesSelector = state => state.user.employees;
export const clientsSelector = state => state.user.clients;
export const userErrorSelector = state => state.user.error;
